import { ADMIN_BROADCAST_STATUSES } from '@steado/admin-contract/broadcasts';
import { z } from 'zod';

export const broadcastsSearchSchema = z.object({
  status: z.enum(ADMIN_BROADCAST_STATUSES).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type BroadcastsSearch = z.infer<typeof broadcastsSearchSchema>;
